export const buildMedicareMyPath = (path: string) => {
  return `${process.env.REACT_APP_BASEPATH ?? ''}${path}`
}
